// const OnayDurums = Object.freeze({
//     RED:   Symbol("red"),
//     BLUE:  Symbol("blue"),
//     GREEN: Symbol("green")
// });

export const ValueTurEnum = Object.freeze({
  Metinsel : 0,
 File : 1,
 Html:2,
 Matrix:3,
 MatrixRow:4,
 MatrixText:5
});

const OnayDurumEnum = Object.freeze({
  OnaySunuldu: 1,
  RedSonrasiDuzeltme: 2,
  Onaylandi: 3,
  Reddet:4,
DuzeltmeliReddet:5
});
export default OnayDurumEnum;